// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Key as RawKey } from "lucide-react";
export const Key = /* @__PURE__ */ createIcon(RawKey, "Key", 2);
